import {createFeatureSelector, createSelector} from '@ngrx/store';
import {generateLoadStatusSelectorsFor, generateSelectorsDependentOn} from '../store.selector-generators';
import {MxSelector, NO_NAME_PREFIX} from '../store.types';
import {FALLBACK_ORGANIZATION} from './organization.fallback';
import {OrganizationState} from './organization.state';
import {Organization, ORGANIZATION_FEATURE_KEY} from './organization.types';
import {isPopulatedString} from '@store/common/typing.helpers';

export const entireState: MxSelector<OrganizationState> = createFeatureSelector(ORGANIZATION_FEATURE_KEY);

export namespace Auth {
  const subState: MxSelector<OrganizationState['auth']> = createSelector(
    entireState,
    state => state.auth
  );

  export const {
    loading,
    loaded,
    finishedLoading
  } = generateLoadStatusSelectorsFor(subState);

  export const organization: MxSelector<Organization> = createSelector(
    subState,
    _subState => _subState.data ?? FALLBACK_ORGANIZATION
  );

  export const {
    name,
    copyOverrides,
    phoneNumber,
    contactEmail,
    coverImageSource,
    novelistProfile,
    novelistPassword,
    enableBowkerMetadata,
    usesMEL,
    opacCardPolicy,
    websiteUrl,
  } = generateSelectorsDependentOn(organization, FALLBACK_ORGANIZATION, NO_NAME_PREFIX);

  export const hasNovelistConfig: MxSelector<boolean> = createSelector(
    novelistProfile,
    novelistPassword,
    (profile, password) => isPopulatedString(profile) && isPopulatedString(password)
  )

} // namespace Auth
